import {v4} from 'uuid'


export default function genId() {
    return v4()
}
